import React, { useEffect, useState } from "react";
import { Box, Card, CardActions, CardContent, CardMedia, Grid, Tooltip, Typography } from "@mui/material";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import { DurationButton, RadioButtonComponent, StarRatingoComponent } from "../../atom";
import { useSelector } from "react-redux";
import moment from "moment";
import { APPROXIMATESIGN, DEFAULT_CURRENCY, getText, onGetCurrencySymble, PLAN_STATUS, REGISTRED_COURSE_STATUS, THEME_COLORS, EXISTING_COURSE_STATUS } from "../../../core/Constant";
import StatusBadge from "../../atom/StatusBadge/StatusBadge";
import _ from "lodash";



const CourseCard = ({
  image,
  title,
  description,
  btnText,
  onCourseDetails = () => {},
  price,
  currancy,
  reviewCount,
  reviewAvg,
  weeks,
  selectValue = 0,
  isRegisterd,
  isFree,
  course,
  plans,
  courseStatus="",
  isMultiBatch,
  onViewMore,
  freeDescription,
  selectedCurrency
}) => {

  const [amount, setAmount] = useState('');
  const [symbole, setSymbole] = useState('');
  const [selectedPlan, setSelectedPlan] = useState();

  const [isShow, setIsShow] = useState(0);
  const show = useSelector(state => state.common.get('show'));

  const isShowApproxiSign = selectedCurrency?.currency !== DEFAULT_CURRENCY
  
  const formattedPlans = plans?.map((plan) => ({
    label: plan?.plan_name || "",
    value: plan?.id || "",
    batch_month: plan?.batch_month || "",
    batch_year: plan?.batch_year || "",
  }))?.slice(0, 2);

  const enrolledPlan = plans?.find((plan)=> plan?.is_enroll === 1 )

  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);

  const getCurrency = (selectedPlan) => {
    if (selectedPlan) {
      const currencySymbol = onGetCurrencySymble(
        _.get(selectedPlan, "currency.currency"),
      );
      localStorage.setItem("GlobalCurrency", selectedPlan?.currency_id);
      return `${selectedPlan?.price && isShowApproxiSign ? APPROXIMATESIGN : "" }${currencySymbol}${selectedPlan?.price}`;
    } else {
      return "";
    }
  };

  useEffect(() => {
    setAmount(price)
  }, [price])

  useEffect(() => {
    setSymbole(currancy)
  }, [currancy])

  const handleRadioChange = (event) => {
    const text = getText(event);
    const selectedPlan = plans?.find((plan) => plan?.id?.toString() === text?.toString());
    setSelectedPlan(selectedPlan);
  };

  useEffect(()=>{
      if(plans?.length > 0){
        const selectedPlan = plans.reduce((min, current) =>
            current.duration_weeks < min.duration_weeks ? current : min
        );
       setSelectedPlan(selectedPlan);
      }else {
        setSelectedPlan("");
      }
    },[plans])

    const enrolledTitle = freeDescription || "";
    const enrolledTitleNeedsTooltip = enrolledTitle?.length > 130;
    const enrolledTitleDisplayedText = enrolledTitleNeedsTooltip
       ? `${enrolledTitle?.substring(0, 130)}...`
       : enrolledTitle;
   
    const courseTitle = title || "";
    const courseNameNeedsTooltip = courseTitle?.length > 50;
    const courseNameDisplayedText = courseNameNeedsTooltip
       ? `${courseTitle?.substring(0, 50)}...`
       : courseTitle;

  const renderPriceContent = () => {
    if (isRegisterd === 1 && courseStatus !== PLAN_STATUS.EXPIRED) {
      return null;
    }

    // If free course
    if (isFree === EXISTING_COURSE_STATUS.FREE) {
      return <DurationButton title="Price" subtitle="Free" />;
    }

    // If paid course
    const formattedPrice = isMultiBatch === EXISTING_COURSE_STATUS.FREE
      ? (selectedPlan ? getCurrency(selectedPlan) : "")
      : `${price && isShowApproxiSign ? APPROXIMATESIGN : ""}${price}`;

    return <DurationButton title="Price" subtitle={formattedPrice} />;
  };

  return (
    <Card sx={{ borderRadius: 8, maxWidth: 370, minWidth: 370, height: "100%", display:"flex", flexDirection:"column"}}>
      <Box
        sx={{
          maxWidth: '370px',
          width: "370px",
          position: "relative",
          backgroundImage:
            "linear-gradient(to top, #2d3945, #292b34, #211e24, #161214, #000000)",
        }}
      >
        <CardMedia
          component="img"
          height="180"
          classes={{ img: "card-image-container" }}
          image={image}
          alt="Card-image"
          style={{ opacity: 0.9 }}
        />
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            color: "white",
            fontFamily: "'Saira Extra Condensed', sans-serif",
            fontWeight: 700,
            fontSize: 40,
            bottom: 0,
            left: 0,
            textShadow: 'rgba(0, 0, 0, 0.5) 0px 0px 10px',
            backgroundColor: "transparent",
            backgroundImage: "linear-gradient(180deg, #FFFFFF00 30%, #000000 100%)"

          }}
        > 
          {courseStatus && <StatusBadge label={courseStatus} />}
          <span style={{ position: "absolute", bottom: 0, left: 20, right:20}}>
            <>
             {courseNameNeedsTooltip ? (
                <Tooltip title={courseTitle} placement="top" arrow>
                  <span style={{ cursor: "pointer" }}>
                    {courseNameDisplayedText}
                  </span>
                </Tooltip>
              ) : (
                courseNameDisplayedText
              )}
            </>
          </span>
        </div>
      </Box>
      <CardContent>
        <Grid container flexDirection={"column"} rowSpacing={2}>
            <Grid item>
                <Grid
                  container
                  sx={{
                    bgcolor: THEME_COLORS.gray4,
                    borderRadius: 2,
                    height:"121px",                  
                    display: "flex",
                    flexDirection: "row",
                    alignItems:"flex-start",
                    justifyContent:"flex-start"
                  }}
                >
                 {
                   isRegisterd === 0 || courseStatus === PLAN_STATUS.EXPIRED ? <>
                   {formattedPlans?.map((plan) => {
                    
                    const planName = plan?.label || "";
                    const needsTooltip = planName?.length > 11;
                    const displayedText = needsTooltip
                       ? `${planName?.substring(0, 11)}...`
                       : planName;

                    const freePlanLabel = freeDescription || "";
                    const freeLabelNeedsTooltip = freePlanLabel?.length > 150;
                    const freeLabelDisplayedText = freeLabelNeedsTooltip
                       ? `${freePlanLabel?.substring(0, 150)}...`
                       : freePlanLabel;

                   return (
                     <Grid
                       item
                       xs={12}
                       key={plan?.value}
                       sx={{
                         height: "40px",
                         display: "flex",
                         alignItems: isFree === 1 ?  "flex-start" : "center",
                       }}
                     >
                      {
                        isFree === 0 ? 
                        (plan?.label || (plan?.batch_month && plan?.batch_year)) ? 
                        <RadioButtonComponent
                         checked={selectedPlan?.id === plan?.value}
                         value={plan?.value}
                         handleChange={handleRadioChange}
                       /> : null : <RadioButtonComponent
                         checked={selectedPlan?.id === plan?.value}
                         value={plan?.value}
                         handleChange={handleRadioChange}
                       />
                      }
                       
                       <Box
                         sx={{
                           minWidth: 0,
                           flex: 1,
                           marginTop: isFree === 1 ? "9px" : "0px"
                         }}
                       >
                         <span
                           style={{
                             fontFamily: "Montserrat, sans-serif",
                             fontSize: "15px",
                             marginRight: 5,
                             color: "#2d3945",
                           }}
                         >
                           {
                             isFree === 1 ? <>
                             {freeLabelNeedsTooltip ? (
                              <Tooltip title={freePlanLabel} placement="top" arrow>
                                <span style={{ cursor: "pointer" }}>
                                  {freeLabelDisplayedText}
                                </span>
                              </Tooltip>
                            ) : (
                              freeLabelDisplayedText
                            )}
                             </> : <>
                           {needsTooltip ? (
                              <Tooltip title={planName} placement="top" arrow>
                                <span style={{ cursor: "pointer" }}>
                                  {displayedText}
                                </span>
                              </Tooltip>
                            ) : (
                              displayedText
                            )}
                            </>
                           }
                         </span>
                
                         <span
                           style={{
                             fontFamily: "Montserrat, sans-serif",
                             fontWeight: 800,
                             fontSize: "15px",
                             color: "#2d3945",
                           }}
                         >
                           {plan?.label && "- "}
                           {plan?.batch_month
                             ? moment()
                                 .month(Number(plan.batch_month) - 1)
                                 .format("MMMM")
                             : ""}{" "}
                           {plan?.batch_year || ""}
                         </span>
                       </Box>
                     </Grid>
                   );
                 })}
                 <Grid
                   item
                   xs={12}
                   sx={{
                     height: "40px",
                     display: "flex",
                     alignItems: "center",
                   }}
                 >
                  {
                    plans?.length > 2 && <Box
                     sx={{
                       pl: 2,
                       cursor: "pointer",
                     }}
                     onClick={() => onViewMore(selectedPlan)}
                   >
                     <Typography
                       component="span"
                       color={THEME_COLORS.primary}
                       fontWeight={700}
                       fontSize={16}
                     >
                       View More
                     </Typography>
                   </Box>
                  }
                  </Grid>
                 
                   </> : <>
                      <Grid
                       item
                       xs={12}
                       sx={{
                         height: isFree === 0 ? "40px" : "100%",
                         display: "flex",
                         alignItems: isFree === 0 ? "center" : "flex-start",
                         paddingTop:1
                       }}
                     >
                      <Box
                         sx={{
                           minWidth: 0,
                           flex: 1,
                           ml:2
                         }}
                       >
                         <span
                           style={{
                             fontFamily: "Montserrat, sans-serif",
                             fontWeight: 800,
                             fontSize: "15px",
                             color: "#2d3945",
                           }}
                         >
                          {
                            isFree === 0 ? <>
                            {
                              course?.student_batch_month ? moment()
                                 .month(Number(course?.student_batch_month) - 1)
                                 .format("MMMM") : ""
                            }{" "}
                            {course?.student_batch_year || ""}
                            </> : <>
                             {enrolledTitleNeedsTooltip ? (
                              <Tooltip title={enrolledTitle} placement="top" arrow>
                                <span style={{ cursor: "pointer" }}>
                                  {enrolledTitleDisplayedText}
                                </span>
                              </Tooltip>
                            ) : (
                              enrolledTitleDisplayedText
                            )}
                             </>
                          }
                          
                         </span>
                       </Box>
                     </Grid>
                   </>
                 }
                 
              </Grid>
           </Grid>
          
          
          <Grid item>
            <Grid container spacing={1}>
             
              <Grid item>
                {isShow ? renderPriceContent() : null}
              </Grid>
            </Grid>
          </Grid>
          
          <Grid item>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignSelf: "center",
                justifyContent: "center",
                backgroundColor: "white",
              }}
            >
              <span style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "13px" }}>
                {reviewCount < 10 ? `0${reviewCount}` : reviewCount} Reviews
              </span>
              <StarRatingoComponent
                readOnly
                selectValue={reviewAvg}
                size={"40"}
              />
            </Box>
          </Grid>
          <Grid item>
            <Grid container flexDirection="column" spacing={0.5}>
              <Grid item>
                <span
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    fontFamily: "Montserrat",
                  }}
                >
                  Description
                </span>
              </Grid>
              <Grid item>
                <Tooltip title={description || ""} placement="top" arrow>
                  <span
                    style={{
                      fontSize: 14,
                      fontWeight: 500,
                      fontFamily: "Montserrat",
                      display: "-webkit-box",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: "vertical",
                      maxHeight: "4.5rem",
                    }}
                  >
                    {description}
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions
         sx={{
           p: "16px",
           mt: "auto",
           paddingBottom: "24px",
         }}
       >
      <Grid container spacing={1.5}>
          <Grid xs={12} item sx={{ display: "flex", justifyContent: "center" }}>
            {isRegisterd == 1 && courseStatus === "" ? (
              <TextButtonComponet
                text={"View"}
                onButtonClick={()=> onCourseDetails("")}
              />
            ) : (
              <TextButtonComponet
                text={"Preview"}
                classStyle="btn course-catalog-preview"
                onButtonClick={()=>{
                  onCourseDetails(selectedPlan)
                }}
              />
            )}
          </Grid>
      </Grid>
      </CardActions>
    </Card>
  );
};

export default CourseCard;
